import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

export type CreateAutoBalanceRows = {
  label: String;
  id: vp.CreateAutoBalanceId;
  require: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
  type: 'input' | 'select' | 'singleDate';
  placeholder: string;
  getSelectOptions: () => { [key: string]: string };
  allowNewOption?: boolean;
};

export const buildCreateAutoBalanceRows = (country: string): CreateAutoBalanceRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AutoBalanceTransfer.Create.Form' });

  const CADOnly: { [key: string]: string } = {
    CAD: 'CAD',
  };
  const USDOnly: { [key: string]: string } = {
    USD: 'USD',
  };

  const FrequencyOptions = {
    Monthly: 'Monthly',
    Daily: 'Daily',
    Weekly: 'Weekly',
    biweekly: 'Bi-Weekly',
  };

  return [
    {
      label: t('currency'),
      id: vp.CreateAutoBalanceId.Currency,
      require: true,
      preset: 'text',
      type: 'select',
      placeholder: '',
      getSelectOptions: () => (country == 'US' ? USDOnly : CADOnly),
    },
    {
      label: t('Balance.label'),
      id: vp.CreateAutoBalanceId.Balance,
      require: true,
      preset: 'number',
      type: 'input',
      placeholder: t('Balance.placeholder'),
      getSelectOptions: () => ({}),
    },
    {
      label: t('StartDate.label'),
      id: vp.CreateAutoBalanceId.StartDate,
      require: true,
      preset: 'date',
      type: 'singleDate',
      placeholder: t('StartDate.placeholder'),
      getSelectOptions: () => ({}),
    },
    {
      label: t('frequency'),
      id: vp.CreateAutoBalanceId.Frequency,
      require: true,
      preset: 'text',
      type: 'select',
      placeholder: '',
      getSelectOptions: () => FrequencyOptions,
    },
  ];
};
